export enum EStoreRoutes {
  Index = "store"
}
